export default __webpack_public_path__ + "images/f2dd210879b54bcfb559d4ee1155487a.svg";